/** Tono visual para el estado de un documento (píldora). */
export function docStatusTone(status: string): 'active' | 'broken' | 'warn' | 'muted' {
  switch (status) {
    case 'paid':
    case 'closed':
    case 'signed':
    case 'accepted':
    case 'approved':
    case 'issued':
      return 'active';
    case 'overdue':
    case 'rejected':
    case 'void':
    case 'expired':
    case 'cancelled':
      return 'broken';
    case 'partially_paid':
    case 'pending':
    case 'sent':
      return 'warn';
    default:
      return 'muted'; // draft y demás
  }
}

/** Nombre de cada etapa de la cadena Necesidad → Recibo. */
export const TRACE_LABELS: Record<string, string> = {
  loi: 'Intención',
  quote: 'Cotización',
  contract: 'Contrato',
  invoice: 'Factura',
  payment: 'Pago',
  receipt: 'Recibo',
};

/** Qué significaría el hueco cuando una etapa no existe todavía. */
export const TRACE_HINTS: Record<string, string> = {
  loi: 'sin carta previa',
  quote: 'sin cotización de origen',
  contract: 'aún sin contrato',
  invoice: 'aún sin factura',
  payment: 'pendiente de cobro',
  receipt: 'sin recibo emitido',
};
